import {
  Avatar,
  Box,
  Button,
  Flex,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import { BsCheckCircleFill, BsChevronRight } from "react-icons/bs";

import { useNavigate, useParams } from "react-router-dom";
import {
  IGetSponsors,
  IUploadedTrainees,
} from "../../../models/admin/sponsors.model";
import SponsorService from "../../../services/admin/sponsors.service";
import AdminDashboardHeader from "../AdminHeader";
import AdminSidebar from "../AdminSidebar";

const TraineesBulkUpload = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { sponsor_id } = useParams();
  const [fileName, setFilename] = useState<string>("");
  const [batchFile, setbatchFile] = useState<FormData | null>(null);
  const [sponsor, setSponsor] = useState<IGetSponsors>();
  const [showUploaded, setShowUploaded] = useState(false);
  const [showupload, setShowUpload] = useState(true);
  const [isSubmit, setIsSubmitting] = useState<boolean>();
  const [uploadedTrainees, setUploadedTrainees] = useState<IUploadedTrainees[]>(
    []
  );
  const [uploadedIds, setUploadedIds] = useState<any[]>([]);

  useEffect(() => {
    SponsorService.getEachSponsor(sponsor_id)
      .then((res) => {
        setSponsor(res);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [uploadedTrainees.length]);

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "30px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };
  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      toast({
        title: "File Upload",
        description: "Invalid file uploaded",
        status: "error",
      });
      setbatchFile(null);
    } else {
      const formData = new FormData();
      const file = acceptedFiles[0];

      formData.append("trainees", file);
      setbatchFile(formData);
      setFilename(file.name);
      toast({
        title: "File Upload",
        description: "Your file is ready for upload",
        status: "success",
      });
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
  const submitFile = () => {
    if (sponsor && batchFile) {
      setIsSubmitting(true);
      SponsorService.batchSponsorTrainees(sponsor.uuid, batchFile)
        .then((res) => {
          setUploadedTrainees(res.data);
          const uploaded_ids: any[] = [];
          setIsSubmitting(false);
          res.data.forEach((trainee: any) => {
            uploaded_ids.push(trainee.id);
          });

          setUploadedIds(uploaded_ids);
          if(uploaded_ids.length > 0) {
            setShowUploaded(true);
          }else{
            navigate(-1);
          }
          setShowUpload(false);

          toast({
            title: "Trainee Upload",
            description: "Trainee uploaded successfully",
            status: "success",
            duration: 2000,
          });
        })
        .catch((err) => {
          toast({
            title: "Trainee Upload",
            description: `${err.response.data.message}`,
            status: "error",
            duration: 2000,
          });
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }else{
      toast({
        title: "File Upload",
        description: "Please select a file to upload",
        status: "error",
      });
    }
  };

  const approveTrainees = async () => {
    try {
      const approved = await SponsorService.approveSponsorTrainees(
        sponsor?.uuid,
        { trainees: uploadedIds }
      );
      if (approved) {
        setUploadedTrainees(approved.data);

        setShowUploaded(true);
        setShowUpload(false);
        navigate("/admin/sponsors/dashboard");

        toast({
          title: "Approve Trainees",
          description: "Trainees approved successfully",
          status: "success",
          duration: 2000,
        });
      }
    } catch (error: any) {
      toast({
        title: "Approve Trainees",
        description: `${error.response.data.message}`,
        status: "error",
        duration: 2000,
      });
    }
  };

  const declineTrainees = async () => {

    try {
      const declined = await SponsorService.declineSponsorTrainees(
        sponsor?.uuid,
        { trainees: uploadedIds }
      );

      if (declined) {
        toast({
          title: "Decline Trainees",
          description: "Trainees declined successfully",
          status: "success",
          duration: 2000,
        });
        navigate(-1);
      }
    } catch (error: any) {
      toast({
        title: "Decline Trainees",
        description: `${error.response.data.message}`,
        status: "error",
        duration: 2000,
      });
    }
  };

  return (
    <>
      <Flex bg="#F9F8F8" minHeight={"100vh"} height={"auto"}>
        <Box width="18%" position="fixed" top="0" left="0" zIndex="1">
          <AdminSidebar />
        </Box>
        <Box width="82%" ml="18%">
          <AdminDashboardHeader />
          <Box bg="#F9F8F8" height="100%" pr="10%" pt="30px" pl="40px">
            <Flex justifyContent="space-between" alignItems="center" py="26px">
              <HStack spacing="5px">
                <Text
                  color="#2B2B2B"
                  fontWeight="500"
                  cursor="pointer"
                  onClick={() => {
                    navigate(-1);
                  }}
                  fontSize="16px"
                >
                  {" "}
                  Sponsor
                </Text>
                <BsChevronRight />
                <Text
                  color="#EC3337"
                  fontWeight="400"
                  cursor="pointer"
                  onClick={() => {
                    navigate(-1);
                  }}
                  fontSize="16px"
                >
                  {" "}
                  {sponsor?.organization_name
                    ? sponsor.organization_name
                    : "nil"}
                </Text>
              </HStack>
            </Flex>
            {showupload && (
              <Box pl="48px" pt="32px" width="100%" bg="white" pb="80px">
                <Text
                  fontWeight="600"
                  fontSize="21px"
                  color="#2B2B2B"
                  mb="90px"
                >
                  Trainees
                </Text>
                <Box mx="auto" width="50%">
                  <form>
                    <div {...getRootProps({ style })}>
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here ...</p>
                      ) : (
                        <p>
                          Drag and drop or browse file <br /> Only Excel(.xsl)
                          files allowed{" "}
                        </p>
                      )}
                    </div>
                    <Text>{fileName}</Text>
                    <Flex justifyContent="center">
                      <Button
                        mt={4}
                        colorScheme="red"
                        size="lg"
                        px={6}
                        isLoading={isSubmit}
                        fontSize="14px"
                        borderRadius="0px"
                        onClick={() => {
                          submitFile();
                        }}
                      >
                        {" "}
                        UPLOAD
                      </Button>
                    </Flex>
                  </form>
                </Box>
              </Box>
            )}

            {showUploaded && (
              <Box bg="#F9F8F8" height="100%" pt="30px" pl="20px" pr="40px">
                <Box bg="white" pb="40px">
                  <Flex pl="15px" py="15px" justifyContent="">
                    <HStack spacing="10px">
                      <BsCheckCircleFill color="#19CB98" />
                      <Text>
                        {uploadedTrainees.length} trainees uploaded successfully
                      </Text>
                    </HStack>
                  </Flex>
                  <Box width="100%">
                    <TableContainer>
                      <Table variant="simple">
                        <Thead mb="10px">
                          <Tr
                            pb="10px"
                            borderBottom="1px solid"
                            borderColor="#D5D5D5"
                          >
                            <Th textTransform="none">Trainee</Th>
                            <Th textTransform="none">Trainee ID</Th>
                            <Th textTransform="none">Gender</Th>
                            <Th textTransform="none">Category</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {uploadedTrainees.map((each, index) => (
                            <Tr key={index} bg="white">
                              <Td>
                                <HStack spacing="10px">
                                  <Avatar name={`${each.name}`} size="sm" />
                                  <Text
                                    fontWeight="600"
                                    fontSize="16px"
                                    color="#616161"
                                  >
                                    {each.name}
                                    <br></br>
                                    {each.email}
                                  </Text>
                                </HStack>
                              </Td>
                              <Td>
                                {" "}
                                <Text>{each.code}</Text>
                              </Td>
                              <Td>
                                {" "}
                                <Text>{each.gender}</Text>
                              </Td>
                              <Td>
                                <Text>{each.category}</Text>
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <Flex
                    justifyContent="flex-end"
                    alignContent="center"
                    mb="30px"
                    mt="30px"
                    mr="10px"
                  >
                    <Button
                      py="13px"
                      px="30px"
                      mt="30px"
                      type="submit"
                      onClick={() => {
                        declineTrainees();
                      }}
                      fontSize={16}
                      bg="#F5F5F5"
                      color="#353535"
                      size="md"
                    >
                      Decline
                    </Button>
                    <Button
                      py="13px"
                      px="30px"
                      mt="30px"
                      ml="20px"
                      onClick={() => {
                        approveTrainees();
                      }}
                      type="submit"
                      fontSize={16}
                      colorScheme="red"
                      size="md"
                    >
                      Approve
                    </Button>
                  </Flex>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default TraineesBulkUpload;
